module.exports = [{"type":"hash","text":"接入方式"},{"type":"normal","text":"行情Websocket的接入URL：wss://open-api-ws.bingx.com/market"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/websocket/introduce/02_connect.json
// module id = Jf00
// module chunks = 3